<script setup lang="ts">
import { useAppSettingsStore } from '@convatec/180medical-website/app/stores/app-settings'

const props = defineProps({
  title: {
    type: String,
  },
  footer: {
    type: String,
  },
})

const appSettingsStore = useAppSettingsStore()

const accessibleName = computed(() => props.title || 'Contact us')

useHubSpotFormA11y('hs-contact-form-container', accessibleName.value)

useHubSpotFormHtml('hs-contact-form-container', () => ({
  portalId: appSettingsStore?.contactSettings?.portalId,
  formId: appSettingsStore?.contactSettings?.formId,
}))
</script>

<template>
  <section
    id="contactForm"
    class="contact-block"
    :aria-label="accessibleName"
  >
    <div class="container-fluid">
      <div class="contact-block__wrap">
        <div
          v-if="title"
          class="h2 font-heading text-[1.625rem] md:text-[2rem] mb-7"
        >
          {{ title }}
        </div>
        <div class="contact-block__card prose">
          <slot />
        </div>
        <div class="contact-block__footer">
          <p
            v-if="footer"
            class="text-sm"
          >
            {{ footer }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@use '@/assets/css/blocks/contact-block.scss';
@use '@/assets/css/forms/hubspot-contact-form.scss';
</style>
